import React from 'react';

import { H5Styled } from './H5.style';

export const H5 = ({ children, ...props }: { children: any }) => {
  return <H5Styled {...props}>{children}</H5Styled>;
};
